import React, { useEffect, useState } from "react";
import MainComponentWrapper from "../../../Common/MainComponentWrapper";
import useHttpHook from "../../../../Hooks/HttpHook";
import TicketTypeForm from "./TicketTypeForm";
import { useSelector, useDispatch } from "react-redux";
import { updCartData } from "../../../../ReduxSlice/Checkout/cartSlice";
import OrderSummamry from "./OrderSummary";
import { GetCart, GetInstallmentsByEvent } from "../../../../utils/ApiConstant";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { showErrorToast } from "../../../../utils/notify";

const PurchaseTickets = (props) => {
  let checked = false,
    quantity = 0;
  const [loading, sendRequest, error] = useHttpHook();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const location = useLocation();
  const [installment, setInstallment] = useState(null);
  useEffect(() => {
    if (cart.status === false) {
      getCartData();
    }
    if (location) {
      getCartData();
      getEmiInstallments();
      props.getEventData();
    }
  }, [location]);

  const getCartData = async () => {
    let cartData = await sendRequest(GetCart + props.eventId, {
      method: "get",
    });
    if (cartData.status === 1) {  
      getEmiInstallments();
      dispatch(updCartData(cartData));
    }
  };
  const getEmiInstallments = async () => {
    const response = await sendRequest(GetInstallmentsByEvent + props.eventId, {
      method: "get",
    });

    if (response.status === 1) {
      setInstallment(response.data);
    }
  };

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);
  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      <div className="event-tickets-body">
        <div className="row g-4 g-xl-5 event-tickets-layout">
          <div className="col-lg-8">
            <div className="event-tickets-list">
              {props.ticketType.length > 0 &&
                props.ticketType?.map(function (ticket, index) {
                  if (cart.status === 1 && cart.data != null) {
                    const ticketIndex = cart.data.tickets.findIndex(
                      (row) => row.id === ticket._id
                    );
                    checked = ticketIndex === -1 ? false : true;
                    quantity =
                      ticketIndex === -1
                        ? 0
                        : cart.data.tickets[ticketIndex].quantity;
                  }
                  return (
                    <TicketTypeForm
                      key={index}
                      eventId={props.eventId}
                      ticket={ticket}
                      quantity={quantity}
                      getCartData={getCartData}
                      checked={checked}
                      isShowRemainingTicket={props.isShowRemainingTicket}
                    />
                  );
                })}
            </div>
          </div>
          <div className="col-lg-4">
            <OrderSummamry
              navigateLink={props.redirectUrl}
              eventId={props.eventId}
              title={props.title}
              mainimage={props?.mainimage}
              cart={cart.data}
            />
          </div>
        </div>
      </div>
    </MainComponentWrapper>
  );
};

export default PurchaseTickets;
